/**
 * 描述：租户管理--所有用户
 * 日期：2017-11-16
 * 作者：liu_jinming
 */
'use strict';
angular.module("servicesConfigModule", ['tManageMentServiceModule', 'checkNameRepeatedModule'])
    .controller("servicesConfigCtrl", ["$scope", "trsspliceString", "$q", "$filter", "tManageMentService", "modalDialog", "trsHttpService",
        function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService) {
            initStatus();
            initData();
            /** [initStatus description]初始化状态 */
            function initStatus() {
                $scope.status = {
                    searchWord: "",
                };
                $scope.data = {
                    copyCurrPage: 1,
                    servicesList: [], //服务名列表
                    selectedServicesList: [], //被选中的服务列表
                };
                $scope.page = {
                    PAGESIZE: 20,
                    PAGECOUNT: 1,
                    ITEMCOUNT: 0,
                    CURRPAGE: 1,
                };
            }
            /** [initData description]初始化数据 */
            function initData() {
                requestData();
            }
            /** [requestData description]获取数据的请求操作 */
            function requestData(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    var params = {
                        serviceid: "mlf_tenant",
                        methodName: 'queryServiceConfig',
                        CURRPAGE: $scope.page.CURRPAGE,
                        PAGESIZE: $scope.page.PAGESIZE,
                        SERVICENAME: $scope.status.searchWord
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $scope.data.servicesList = data.DATA;
                        $scope.page = data.PAGER;
                        $scope.data.copyCurrPage = $scope.page.CURRPAGE;
                    });
                }
            }
            /** [requestData description] 页面进行新的请求 */
            $scope.requestData = function() {
                requestData();
            }
            /** [jumpToPage description]手动输入页码进行跳转的操作 */
            $scope.jumpToPage = function() {
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };
            /** [selectedServices description]选择服务的操作 */
            $scope.selectedServices = function(item) {
                var num = $scope.data.selectedServicesList.indexOf(item.SERVICECONFIGID);
                if (num > -1) {
                    $scope.data.selectedServicesList.splice(num, 1);
                } else {
                    $scope.data.selectedServicesList.push(item.SERVICECONFIGID);
                }
            };
            /** [selectAll description]全选操作 */
            $scope.selectAll = function() {
                if ($scope.data.selectedServicesList.length === $scope.data.servicesList.length && $scope.data.servicesList.length > 0) {
                    $scope.data.selectedServicesList = [];
                } else {
                    for (var i = 0; i < $scope.data.servicesList.length; i++) {
                        $scope.data.selectedServicesList.push($scope.data.servicesList[i].SERVICECONFIGID);
                    }
                }
            };
            /** [createService description]新建服务 */
            $scope.createService = function() {
                tManageMentService.createEditService().then(function() {
                    requestData();
                });
            };
            /** [editservice description] 编辑企业 */
            $scope.editservice = function(item) {
                tManageMentService.createEditService(item).then(function() {
                    requestData();
                });
            };
            /** [viewDetails description] 点击查看详情 */
            $scope.viewDetails = function(item, num) {
                tManageMentService.createEditService(item, num);
            };
            /** [switchBtn description]切换服务的状态 */
            $scope.switchBtn = function(item) {
                if (item.STATUS == '1') {
                    item.STATUS = '0';
                    deactivate(item);
                } else {
                    item.STATUS = '1';
                    activate(item);
                }
            };
            /** [statusChange description] 禁用服务*/
            function deactivate(item) {
                var params = {
                    serviceid: "mlf_tenant",
                    methodname: "deactivateServiceConfig",
                    SERVICECONFID: item.SERVICECONFIGID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.TYPE == '3') {
                        modalDialog.alertType("", "服务禁用成功!", 'success', false);
                        requestData();
                    } else {
                        item.STATUS = '1';
                        modalDialog.alertType("", "当前服务已有租户在使用,若禁用,则会导致服务无法使用!", 'error', "confirm");
                    }
                });
            }
            /** [statusChange description] 启用服务*/
            function activate(item) {
                var params = {
                    serviceid: "mlf_tenant",
                    methodname: "activateServiceConfig",
                    SERVICECONFID: item.SERVICECONFIGID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType("", "启用成功!", 'success', false);
                    requestData();
                });
            }
        }
    ]);